import React, { Fragment, useEffect, useState } from "react";
import Vocabulary from '../components/Vocabulary';
const ListPage = () => {

    const [streetarts, setStreetarts] = useState([]);


    const fetchStreetArts = async () => {
        try {
          const response = await fetch(`/api/search`);
          const jsonData = await response.json();
          setStreetarts(jsonData);
        } catch (err) {
          console.error("Error fetching street arts:", err);
        }
      };

      useEffect(() => {
        fetchStreetArts();
      }, []);


return (
    <Fragment>
      <div className="container">
      <Vocabulary />
      </div>
    </Fragment>
);
}



export default ListPage;